<template>
    <div class="relative h-screen-index">
        <div class="flex">
            <Sidebar class="!hidden md:!block" />
            <div class="w-full px-2 md:py-2">
                <keep-alive include="albums,artists,tracks,genres,genre,artist-tracks" max="18">
                    <router-view :key="$route.path"></router-view>
                </keep-alive>
            </div>
        </div>
        <div class="fixed bg-base-300/95 rounded-xl shadow-xl visible bottom-[65px] md:bottom-6 left-0 md:left-1/4 w-[95%] md:w-1/2 mx-[2.5%] md:mx-auto z-[19]">
            <Player />
        </div>
        <div class="drawer">
            <input id="showBar" type="checkbox" class="drawer-toggle" v-model="isShowSideBar" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side z-10">
                <label for="showBar" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content">
                    <Sidebar />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Sidebar from '@/components/library/Sidebar'
    import Player from '@/views/library/player/Player'
    export default {
        components: {
            Sidebar, Player
        },
        data() {
            return {
                isShowSideBar: false
            }
        },
        methods: {
            showSideBar() {
                this.isShowSideBar = !this.isShowSideBar
            }
        }
    }
</script>
